/** 行程核价与确认件共同使用的大巴车型目录。 */
export const BUS_VEHICLE_SEAT_OPTIONS = [37, 47, 48, 49, 53, 55] as const;

/** 可在确认件包车录入中选择的规范车型文本。 */
export const BUS_VEHICLE_SPEC_OPTIONS = BUS_VEHICLE_SEAT_OPTIONS.map((seat) => `${seat}座`);

/** 判断包车规格是否以车型目录中的规范座位数开头。 */
export function isSupportedBusVehicleSpec(value: string): boolean {
  const seat = Number(value.trim().match(/^(\d+)座/u)?.[1]);
  return BUS_VEHICLE_SEAT_OPTIONS.some((candidate) => candidate === seat);
}
